'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z' });

var Kitchen = function Kitchen(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Kitchen = (0, _pure2.default)(Kitchen);
Kitchen.muiName = 'SvgIcon';

exports.default = Kitchen;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Kitchen.js
// module id = 2527
// module chunks = 0